<template>
  <v-dialog v-model="dialog" max-width="600px">
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs6>
                <v-menu
                  ref="dateMenu"
                  v-model="dateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="editedPosition.date"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :value="editedPosition.date | moment('DD.MM.YYYY')"
                      label="Datum*"
                      prepend-inner-icon="event"
                      readonly
                      required
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="editedPosition.date" no-title scrollable locale="de" first-day-of-week="1">
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="dateMenu = false">Abbrechen</v-btn>
                    <v-btn flat color="primary" @click="$refs.dateMenu.save(editedPosition.date)">OK</v-btn>
                  </v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12>
                <v-autocomplete
                  v-model="editedPosition.code"
                  label="Tarifziffer*"
                  required
                  :rules="codeRules"
                  clearable
                  hint="TARMED Leistungsnummer oder Leistungstitel eingeben"
                  persistent-hint
                  :loading="searchCodeIsLoading"
                  :search-input.sync="searchCode"
                  :items="searchCodeServices"
                  :filter="v => v"
                  hide-no-data
                  item-value="code"
                  item-text="code"
                  return-object
                >
                  <template slot="item" slot-scope="{ parent, item, tile }">
                    <v-list-tile-content>
                      <!--<v-list-tile-title v-text="item.code"></v-list-tile-title>-->
                      <v-list-tile-title v-html="highlight(item.code, searchCode)"></v-list-tile-title>
                      <!--<v-list-tile-sub-title v-text="item.title"></v-list-tile-sub-title>-->
                      <!--<v-list-tile-sub-title v-html="`${parent.genFilteredText(item.title)}`"></v-list-tile-sub-title>-->
                      <v-list-tile-sub-title v-html="highlight(item.title, searchCode)"></v-list-tile-sub-title>
                    </v-list-tile-content>
                  </template>
                </v-autocomplete>
              </v-flex>
              <v-flex xs12>
                <!--
                <v-text-field
                  v-model="editedPosition.ref_code"
                  label="Bezugsziffer"
                  hint="TARMED Leistungsnummer oder Leistungstitel eingeben"
                  persistent-hint
                ></v-text-field>
                -->
                <v-autocomplete
                  v-model="editedPosition.ref_code"
                  label="Bezugsziffer"
                  clearable
                  hint="TARMED Leistungsnummer oder Leistungstitel eingeben"
                  persistent-hint
                  :loading="searchRefCodeIsLoading"
                  :search-input.sync="searchRefCode"
                  :items="searchRefCodeServices"
                  :filter="v => v"
                  hide-no-data
                  item-value="code"
                  item-text="code"
                >
                  <template slot="item" slot-scope="{ parent, item, tile }">
                    <v-list-tile-content>
                      <v-list-tile-title v-html="highlight(item.code, searchRefCode)"></v-list-tile-title>
                      <v-list-tile-sub-title v-html="highlight(item.title, searchRefCode)"></v-list-tile-sub-title>
                    </v-list-tile-content>
                  </template>
                </v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="editedPosition.session"
                  label="Sitzung*"
                  required
                  :rules="sessionRules"
                  type="number"
                  min="1"
                  max="2"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="editedPosition.quantity"
                  label="Anzahl*"
                  required
                  :rules="amountRules"
                  type="number"
                  min="1"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="close">{{ cancelButtonLabel }}</v-btn>
          <v-btn color="primary" flat @click="save" :disabled="!valid">{{ submitButtonLabel }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: Boolean,
    editedPosition: Object,
    editedIndex: Number,
    tarmedVersion: String
  },

  data() {
    return {
      valid: true,
      dateMenu: false,
      searchCode: null,
      searchCodeIsLoading: false,
      searchCodeServices: [],
      searchRefCode: null,
      searchRefCodeIsLoading: false,
      searchRefCodeServices: [],
      // validation rules
      codeRules: [v => !!v || 'Tarifziffer benötigt'],
      sessionRules: [
        v => !!v || 'Sitzung benötigt',
        v => (v >= 1 && v <= 2) || 'Erlaubte Werte: 1, 2 (max. 2 Sitzungen während Testphase)'
      ],
      amountRules: [v => !!v || 'Anzahl benötigt']
    }
  },

  computed: {
    dialog: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },

    formTitle() {
      return this.editedIndex === -1 ? 'Position hinzufügen' : 'Position bearbeiten'
    },

    cancelButtonLabel() {
      return this.editedIndex === -1 ? 'Schliessen' : 'Abbrechen'
    },

    submitButtonLabel() {
      return this.editedIndex === -1 ? 'Hinzufügen' : 'Speichern'
    }
  },

  watch: {
    searchCode(value) {
      // services have already been requested
      if (this.searchCodeIsLoading) return

      // if value was removed (clearable), deleted (backspace) or no initial value was given
      if (!value || value.length == 0) {
        this.editedPosition.code = ''
        this.searchCodeServices = []
        return
      }

      // only send when words or numbers are listed in pattern, not stuff like: "+ " for "+ zusch" when typing
      if (!/[a-z0-9]/i.test(value)) {
        return
      }

      this.searchCodeIsLoading = true

      // TODO: rename req -> response
      // this.$http.get(`/services/texts?tarmed_version=${this.tarmedVersion}&q=${value}`)
      // this.$http.get(`/tarmed/services?tarmed_version=${this.tarmedVersion}&include=service_text&filter[service_text.title][contains]=${value}`)
      // this.$http.get(`/common/items?tarmed_version=${this.tarmedVersion}&filter[tariff]=001&filter[code][contains]=${value}`)
      this.$http
        .get(`/common/search-items?tarmed_version=${this.tarmedVersion}&filter[tariff]=001&filter[query]=${value}`)
        .then(response => {
          let services = []

          for (let i = 0; i < response.data.length; i++) {
            services.push({ code: response.data[i].code, title: response.data[i].name })
          }

          this.searchCodeServices = services
        })
        .catch(error => {
          console.error(error)
        })
        .finally(() => (this.searchCodeIsLoading = false))
    },

    // TODO: refactor with searchCode
    searchRefCode(value) {
      // services have already been requested
      if (this.searchRefCodeIsLoading) return

      // if value was removed (clearable), deleted (backspace) or no initial value was given
      if (!value || value.length == 0) {
        this.editedPosition.ref_code = ''
        this.searchRefCodeServices = []
        return
      }

      // only send when words or numbers are listed in pattern, not stuff like: "+ " for "+ zusch" when typing
      if (!/[a-z0-9]/i.test(value)) {
        return
      }

      this.searchRefCodeIsLoading = true

      this.$http
        .get(`/common/search-items?tarmed_version=${this.tarmedVersion}&filter[tariff]=001&filter[query]=${value}`)
        .then(response => {
          let services = []

          for (let i = 0; i < response.data.length; i++) {
            services.push({ code: response.data[i].code, title: response.data[i].name })
          }

          this.searchRefCodeServices = services
        })
        .catch(error => {
          console.error(error)
        })
        .finally(() => (this.searchRefCodeIsLoading = false))
    },

    /**
     * for the edit action, we need to call the API to make sure
     * the items are filled with the edited code.
     * otherwise the code string is not displayed, because Vuetify only
     * displays elements, found in the items
     * @see https://github.com/vuetifyjs/vuetify/issues/7609
     *
     * This solution calls the API automatically, because updating the array
     * of items (.push(...) will sync the search-input (.sync=...) which will
     * call the watcher
     */
    dialog(value) {
      // reset validation on opening dialog (did not work after close)
      if (value) this.$refs.form.resetValidation()

      //value || this.close()
      // dialog opened (value: true) in edit mode (index > -1)
      if (value && this.editedIndex > -1) {
        if (this.editedPosition.code && this.editedPosition.code.length > 0) {
          this.searchCodeServices.push({ code: this.editedPosition.code, title: '' })
        }
        if (this.editedPosition.ref_code && this.editedPosition.ref_code.length > 0) {
          this.searchRefCodeServices.push({ code: this.editedPosition.ref_code, title: '' })
        }
      }
    }
  },

  methods: {
    close() {
      this.dialog = false
    },

    save() {
      /**
       * This is the hack to retrieve the title from the selected code.
       * Together with return-object at autocomplete, it works
       */
      if (!this.$refs.form.validate()) return

      if (typeof this.editedPosition.code === 'object') {
        let code = this.editedPosition.code.code
        let title = this.editedPosition.code.title
        this.editedPosition.code = code
        this.editedPosition.title = title
      }
      this.$emit('create-or-update', this.editedPosition)
      this.close()
    },

    /**
     * monkey-patched methods to highlight the typed text
     * TODO: check with Vuetify issues if this is a bug
     * https://github.com/vuetifyjs/vuetify/blob/8a5760c6b6a184c9c8f41cbfebf079dbaa3ccc43/packages/vuetify/src/components/VSelect/VSelectList.js#L131
     * this line marks everything, even if there is no match
     * but only, when used like this:
     *
     * <v-list-tile-sub-title v-html="`${parent.genFilteredText(item.title)}`"></v-list-tile-sub-title>
     *
     * source:
     * https://stackoverflow.com/questions/52820450/vuetify-autocomplete-item-slot-keep-the-highlighting-of-character
     */
    highlight(text, searchInput) {
      const index = text.toLocaleLowerCase().indexOf(searchInput)

      if (index < 0) return text

      const start = text.slice(0, index)
      const middle = text.slice(index, index + searchInput.length)
      const end = text.slice(index + searchInput.length)

      const highlightedText = `<span class="v-list__tile__mask">${this.escapeHTML(middle)}</span>`

      return `${this.escapeHTML(start)}${highlightedText}${this.escapeHTML(end)}`
    },

    escapeHTML(string) {
      const tagsToReplace = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;'
      }

      return string.replace(/[&<>]/g, tag => tagsToReplace[tag] || tag)
    }
  }
}
</script>

<style scoped></style>
